document.addEventListener('DOMContentLoaded', function() {

    const elementsToHide = ['#gorgias-chat-container', '.needsclick', '#chat-campaigns']; // Add popup elements to this array to hide for robot testing

    const userAgent = window.navigator.userAgent;

    if(userAgent.includes('Arkhi Robot Testing')) {
        function waitForElm(selector) {
            return new Promise(resolve => {
                if (document.querySelector(selector)) {
                    return resolve(document.querySelector(selector));
                }
        
                const observer = new MutationObserver(mutations => {
                    if (document.querySelector(selector)) {
                        resolve(document.querySelector(selector));
                        // observer.disconnect();
                    }
                });
        
                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            });
        }

        elementsToHide.forEach(element => {
            let selector = document.querySelectorAll(element);

            if(selector.length > 0) {
                selector.forEach(elem => {
                    elem.classList.add('robot-display-none');
                });
            }
            waitForElm(element).then((elm) => {
                elm.classList.add('robot-display-none');
            });
    });

    }
});
